import React from "react";
import { getSize } from "../../utils/size";
import { classnames, combinePrefixes } from "../../utils/text";
import TabList from "../Tab";

const ModalTab = ({
  type = 'default',
  size = 'lg', // lg, md, sm ,x-sm
  className,
  tabList,
  active,
  tabClassName = "",
}) => {
  return <>
    <div
      className={
        classnames(
          combinePrefixes(`modal-tab`, [type.toLowerCase(), getSize(size),], '-', true),
          className
        )
      }>
      <TabList
        className={tabClassName}
        tabList={tabList}
        active={active}
      />
    </div>
  </>;
};

export default ModalTab;